import { buildVenuePath } from '../utils/venueRouting';
// src/pages/Discover.jsx
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import AdvTabs from '../components/AdvTabs';
import SearchTabs from '../components/SearchTabs';
import { contentLog } from '../utils/Accesslog.js';
import { resolveSidebarIconSrc } from '../utils/IconSource.js';

const Discover = () => {
  const { hotelInfo, contentInfo, articleInfo, venueId, theme } = useContext(AppContext);
  const navigate = useNavigate();

  const handleServiceClick = (data) => {
    contentLog(venueId, data.id);
    if (data.isLeaf) {
      navigate(buildVenuePath(`/discover/detail/${data.id}`, venueId));
    }
    else
      navigate(buildVenuePath(`/discover/list/${data.id}`, venueId))
  }
  if (!hotelInfo) { return <div>Loading...</div>; }

  const discoverHeader = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)'  : (theme?.discoverHeader || 'rgb(0,0,0)');
  const discoverContent = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.discoverContent || 'rgb(0,0,0)');
  const discoverLearnMore = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.discoverLearnMore || 'rgb(0,0,0)');
  const discoverCardsTitle = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)'  : (theme?.discoverCardsTitle || 'rgb(0,0,0)');
  const discoverArticlesTitle = (theme?.color || theme?.secondaryColor) ?  'rgb(0,0,0)' : (theme?.discoverArticlesTitle || 'rgb(0,0,0)');

  const discoverBackground = (theme?.color || theme?.secondaryColor) ? 'rgb(255,255,255)' : (theme?.discoverBackground || 'rgb(255,255,255)');
  const discoverEntriesBackground = (theme?.color || theme?.secondaryColor) ? 'rgb(243,244,246)' : (theme?.discoverEntriesBackground || 'rgb(243,244,246)');
  const discoverCardsBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : (theme?.discoverCardsBackground || 'rgb(255,255,255)');
  const discoverArticlesBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : (theme?.discoverArticlesBackground || 'rgb(255,255,255)');



  return (
    <div>
      <div className={`absolute z-10 mx-2 rounded-md left-0 right-0 bg-white shadow-2xl`} style={{ top: '5.5rem' }}>
        <SearchTabs />
      </div>
      {articleInfo && articleInfo.length > 0 && <div style={{ backgroundColor: discoverBackground }}>
        <img src={articleInfo[0].image} alt='serviceImage' className='object-cover w-full h-[48.8vw] xs:max-w-md xs:max-h-64 mx-auto' />
        <p className='px-4 pt-4 pb-2 text-lg font-semibold' style={{ color: discoverHeader }}>{articleInfo[0].name}</p>
        <p className='px-4 text-sm' style={{ color: discoverContent }}>{articleInfo[0].description}</p>
        <p className='px-4 py-4 text-sm font-semibold' onClick={() => { navigate(buildVenuePath(`/article/${articleInfo[0].id}`, venueId)) }} style={{ color: discoverLearnMore }}>Learn more</p>
      </div>}
      <div className='py-4 overflow-hidden relative' style={{ backgroundColor: discoverEntriesBackground }}>

        <p className='font-semibold text-center text-lg pb-4' style={{ color: discoverHeader }}>Discover the Area</p>
        <div className='grid grid-cols-2 max-w-md mx-auto px-2'>
          {contentInfo && contentInfo.attributes
            .filter(data => data.searchTags === "AreaManagedEndpoint") // 筛选出 searchTags 为 "AreaManagedEndpoint" 的节点
            .flatMap(data => data.attributes || []) // 展平其内部子节点
            .map((subData, index) => {
              const iconSrc = resolveSidebarIconSrc(subData);
              return (
                <div key={subData.id} className="flex flex-col items-center px-2 py-2 m-2  rounded-lg min-h-28"
                  style={{ backgroundColor: discoverCardsBackground }}
                  onClick={() => handleServiceClick(subData)}>
                  <div className="w-full flex items-center justify-center m-2">
                    {iconSrc && (
                      <img
                        src={iconSrc}
                        alt={"IconImage " + index}
                        className="object-cover rounded-lg w-12 h-12 "
                        onError={(event) => {
                          event.currentTarget.style.display = 'none';
                        }}
                      />
                    )}
                  </div>
                  <p className="font-semibold text-center mt-0 text-sm" style={{ color: discoverCardsTitle }}>{subData.name}</p>
                </div>
              );
            })}
        </div>
      </div>
      <AdvTabs origin={'Discover'} />
      <div className='py-4' style={{ backgroundColor: discoverBackground }}>
        <p className='pt-4 pb-4 font-semibold text-lg text-center' style={{ color: discoverHeader }}>Featured Articles</p>
        {articleInfo && articleInfo.map((data, index) => (
          <div key={index} className="flex items-center mx-4 my-2 border"
            style={{ boxShadow: '0 0.3rem 0.3rem rgba(0, 0, 0, 0.1)', backgroundColor: discoverArticlesBackground }}
            onClick={() => { navigate(buildVenuePath(`/article/${data.id}`, venueId)) }}>
            <div className="w-28 h-28 bg-gray-300 flex-shrink-0">
              <img src={data.image} alt={data.name} className="w-full h-full object-cover" />
            </div>
            <div className="ml-4 flex-grow" >
              <p className="font-semibold text-sm pb-2" style={{color: discoverArticlesTitle}}>{data.name}</p>

            </div>
          </div>
        ))}
      </div>

      <AdvTabs origin={'Discover'} />
    </div>
  );
};

export default Discover;
